<template>
  <section class="container m-auto h-full container flex justify-center items-center sm:h-full md:h-screen lg:h-screen xl:h-screen">   
    <div class="w-3/4 sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-2/3" v-bind:class="[ error ? 'p-12 border-2 rounded-md border-red-800 bg-red-200' : '']">
      <p v-if="error" class="text-center text-2xl text-red-800 mb-6">{{error}}</p>
      <div class="max-w-full mb-6 text-2xl text-gray-800 leading-8">
        <span class="text-base text-blue-500 leading-7">{{question.prefix}}.</span> 
        {{question.text}}
      </div>
      <p v-if="question.secondaryText" class="text-gray-600">{{question.secondaryText}}</p>
      <div v-if="question.displayType=='button-list'" class="w-full max-w-lg">
        <div class="grid grid-cols-1 my-10 gap-3">
          <div class="col-span-1 inline-block" v-for="(option,index) in question.answerOption" :key="index">
            <choice-button :chosen="queryChosen(option.value.value)" v-bind="{option}" @answer="onAnswer(option.value)" @utterance="readQuestion"></choice-button>
          </div>
        </div>
      </div>
      <div v-else-if="question.displayType=='scale'">
        <div class="grid" :class="[ question.answerOption[0].valueType === 'imageChoice' ? gridColumnsClass : gridRowsClass ]">
            <div v-for="(option,index) in question.answerOption" :key="index">
              <choice-button v-if="option.valueType==='radio'" :chosen="queryChosen(option.value.value)" v-bind="{option}" @answer="onAnswer(option.value)" @utterance="readQuestion"></choice-button>
              <choice-image v-else-if="option.valueType==='imageChoice'" :chosen="queryChosen(option.value.value)" v-bind="{option}" @answer="onAnswer(option.value)" @utterance="readQuestion"></choice-image>
            </div>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
  import ChoiceButton from '@/components/ChoiceButton.vue'
  import ChoiceImage from '@/components/ChoiceImage.vue'

  export default {
    props: ['index', 'question', 'error'],
    data() {
      return {
        answer: undefined,
      }
    },
    components: {
      ChoiceButton, ChoiceImage
    },
    computed: {
      gridColumnsClass () {
        return `grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-${this.question.answerOption.length} my-5 gap-3 sm:gap-3 md:gap-5 lg:gap-5 xl:gap-5`
      },
      gridRowsClass () {
        return `grid-flow-col grid-rows-${this.question.answerOption.length} sm:grid-rows-${this.question.answerOption.length} md:grid-rows-3 lg:grid-rows-2 xl:grid-rows-2 my-5 gap-5`
      }
    },
    methods: {
      onAnswer(chosenAnswer) {
        // if a single-answer question
        if (this.question.type === 'choice' && this.answer === undefined) {
          this.answer = chosenAnswer.value
          this.$emit('answered', this.question, chosenAnswer)
        } else if (this.question.type === 'open-choice' && this.answer === undefined) {
          this.answer.push(chosenAnswer.value)
        }
        else {
          this.answer = undefined;
          this.$emit('answered', this.question, undefined)
        }
      },
      queryChosen(optionValue) { // for conditional styling if an option has been selected
        if (Array.isArray(this.answer)) { 
          return this.answer.some((ans) => ans.value === optionValue)
        } else if (this.answer) {
          if (this.answer === undefined) {
            return false
          } else {
            return optionValue === this.answer
          }
        }
        return false;
      },
      readQuestion(questionText) {
        console.log(`reading question with text ${questionText}`)
        const synth = window.speechSynthesis;
        const questionSpeech = new SpeechSynthesisUtterance(questionText);
        synth.speak(questionSpeech);
      }
    }
  }
</script>